import { createFileRoute } from "@tanstack/react-router";
import EsServicePage from "@/pages/es/EsServicePage";
import { esTmsAnxiety } from "@/pages/es/esServiceData";
import { SITE_URL, buildHreflang } from "@/lib/i18n/locale";

const ES_URL = `${SITE_URL}/es/services/anxiety`;

export const Route = createFileRoute("/es/services/anxiety")({
  head: () => ({
    meta: [
      { title: "TMS para la ansiedad | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "TMS Apollo para la ansiedad crónica en Coral Springs, FL. Neuromodulación no invasiva cuando los medicamentos no son suficientes Free consultation available.",
      },
      {
        property: "og:title",
        content: "TMS para la ansiedad | Neuro Wellness TMS",
      },
      {
        property: "og:description",
        content:
          "Terapia TMS Apollo no invasiva para la ansiedad crónica en Coral Springs, FL.",
      },
      { property: "og:url", content: ES_URL },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_ES" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "TMS para la ansiedad | Neuro Wellness TMS",
      },
      {
        name: "twitter:description",
        content:
          "Terapia TMS Apollo no invasiva para la ansiedad crónica en Coral Springs, FL.",
      },
    ],
    links: [
      { rel: "canonical", href: ES_URL },
      ...buildHreflang("/services/anxiety"),
    ],
  }),
  component: () => <EsServicePage cfg={esTmsAnxiety} />,
});
